import React from 'react';
import { useLanguage } from './LanguageContext';
export const SpecialOffer = () => {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand-navy py-16" style={{
    borderTop: '2px solid #C9A84C',
    borderBottom: '2px solid #C9A84C'
  }} data-id="element-233">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-234">
        <div className="text-brand-gold text-2xl mb-4" data-id="element-235">✦</div>
        <h2 className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-white leading-tight mb-5" data-id="element-236">
          {t('offer.title')}
        </h2>
        <p className="font-inter text-[17px] text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-237">
          {t('offer.sub')}
        </p>
        <a href="tel:7866603720" className="inline-flex items-center bg-brand-gold hover:bg-white text-brand-navy font-montserrat font-extrabold h-[56px] px-10 rounded-[28px] transition-colors" data-id="element-238">
          {t('offer.cta')}
        </a>
      </div>
    </section>;
};